import {Component, Input} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-aanvullende-vragen',
  templateUrl: './aanvullende-vragen.component.html',
  styleUrls: ['./aanvullende-vragen.component.scss'],
})
export class AanvullendeVragenComponent {

    @Input() partner = new BehaviorSubject<boolean>(false);

}
